import styled from "styled-components";

export interface LabelProps {
  color?: string;
  display?: string;
}

export const Label = styled.span<LabelProps>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: inherit;

  ${({ display }) =>
    display ? `display: ${display} !important;` : ""}

  ${({ color }) =>
    color ? `color: ${color} !important;` : ""}
`;